<div class="punti-firma-fullscreen">
	<!-- Barra Superiore -->
	<div class="punti-firma-header d-flex align-items-center px-4">
		@if (!isPublic()) {
			<button class="btn-back-kf d-flex align-items-center gap-2" (click)="goBack()">
				<i class="bi bi-arrow-left"></i>
				<span>Torna indietro</span>
			</button>
		}
		@if (totalInQueue() > 1) {
			<div class="ms-auto">
				<span class="badge bg-confirm-kf rounded-pill px-3 py-2">
					Pratica {{ currentQueueIndex() }} di {{ totalInQueue() }}
				</span>
			</div>
		}
	</div>

	@if (signatureCompleted()) {
		<div class="d-flex flex-column align-items-center justify-content-center w-100" style="height: calc(100vh - 60px); background: #fff;">
			<div class="text-center p-5" style="max-width: 480px;">
				<i
					class="bi"
					[class.bi-check-circle-fill]="!isRejected()"
					[class.bi-x-circle-fill]="isRejected()"
					[style.color]="isRejected() ? '#e74c3c' : '#27ae60'"
					style="font-size: 5rem;"></i>
				<h2 class="mt-4 mb-3" style="font-size: 1.8rem; color: #2C3E50; font-weight: 700;">
					{{ isRejected() ? 'Pratica rifiutata con successo' : 'Pratica conclusa con successo' }}
				</h2>
				<p style="color: #6c757d; font-size: 1rem;">
					{{ isRejected() ? 'Hai rifiutato la firma per questa pratica. Puoi chiudere questa pagina.' : 'Grazie! La tua firma è stata registrata correttamente. Puoi chiudere questa pagina.' }}
				</p>
			</div>
		</div>
	} @else {
		<div class="punti-firma-content d-flex">
			<!-- Barra Laterale -->
			<div class="punti-firma-sidebar">
				<div class="sidebar-scrollable p-3">
					@for (doc of praticaDetail()?.documents; track doc.documentID; let docIdx = $index) {
						<div class="doc-item mb-4 pb-2 border-bottom">
							<h6 class="doc-title text-truncate mb-3" [title]="doc.fileName" style="font-size: 0.9rem; color: #6c757d;">
								<i class="bi bi-file-earmark-text me-2"></i>
								{{ doc.fileName }}
							</h6>
							<div class="thumbnails-grid">
								@for (page of getPagesForDocument(docIdx); track page.globalPage) {
									<div class="thumbnail-wrapper" [class.active]="currentPage() === page.globalPage" (click)="goToPage(page.globalPage)">
										<div class="thumbnail-placeholder">
											<img [src]="pageUrls()[page.globalPage - 1]" class="img-fluid" />
										</div>
										<span class="page-number text-muted">{{ page.localPage }}</span>
									</div>
								}
							</div>
						</div>
					}
				</div>

				@if (showFirmaMultipla()) {
					<div class="px-3 pb-2 border-top pt-2">
						<div class="form-check form-switch mb-2">
							<input class="form-check-input" type="checkbox" id="firmaMultiplaSwitch" [checked]="firmaMultipla()" (change)="firmaMultipla.set($any($event.target).checked)">
							<label class="form-check-label fw-semibold small" for="firmaMultiplaSwitch">Firma Multipla</label>
						</div>
						@if (firmaMultipla()) {
							<div class="alert alert-warning py-2 px-3 small mb-0">
								<strong>Attenzione</strong><br>
								Stai per firmare la pratica in modo automatico. Proseguendo, confermi di accettare integralmente il contenuto dei documenti e dichiari di assumerti ogni responsabilità derivante dalla loro firma.
							</div>
						}
					</div>
				}
				<!-- Pulsanti di Azione -->
				<div class="punti-firma-sidebar-footer p-3 d-flex gap-2">
					<button class="btn btn-danger w-50" (click)="openRifiutaModal()">RIFIUTA</button>
					<button class="btn btn-confirm-kf w-50" (click)="conferma()" [disabled]="!allRequiredSigned()">CONFERMA</button>
				</div>
			</div>

			<!-- Visualizzatore Principale -->
			<div class="punti-firma-viewer flex-grow-1 position-relative" [class.fullscreen-viewer]="isFullscreen()">
				@if (loadingPage()) {
					<div class="viewer-loader">
						<div class="spinner-border text-primary"></div>
					</div>
				} @else {
					<div class="viewer-canvas-wrapper" (scroll)="onScroll($event)">
						@for (url of pageUrls(); track i; let i = $index) {
							<div
								[id]="'page-' + (i + 1)"
								class="document-page active-page-shadow"
								[style.width.%]="zoomLevel() * 100"
								style="background: white; position: relative; margin-bottom: 40px;">
								<img [src]="url" style="width: 100%" class="shadow" />

								<div class="signature-overlay" style="width: 100%">
									@for (field of getFieldsForPage(i + 1); track field.signatureFieldID) {
										<div
											[id]="'field-' + field.signatureFieldID"
											class="web-sign-field"
											[class.required]="field.required"
											[class.signed]="field.firmato"
											[style.width.%]="field.w"
											[style.height.%]="field.h"
											[style.left.%]="field.y"
											[style.bottom.%]="field.x"
											(click)="signField(field)">
											<i class="bi" [class.bi-pen]="!field.firmato" [class.bi-check-lg]="field.firmato"></i>
											<span class="small">{{ field.firmato ? 'Firmato' : (field.required ? 'Firma obbligatoria' : 'Firma opzionale') }}</span>
										</div>
									}
								</div>
							</div>
						}
					</div>

					<!-- Box di Aiuto Fluttuante -->
					<div class="add-point-info-box shadow d-flex flex-column gap-3">
						<div>
							<h6>Firma la pratica</h6>
							<p class="small mb-0">Leggi il documento e clicca sulle aree evidenziate per firmare.</p>
						</div>
						@if (!isAllSigned()) {
							<button class="btn btn-sm w-100 fw-bold" style="background: white; color: #7c6ff7; border: none;" (click)="goToNextUnsigned()">
								<i class="bi bi-arrow-right-circle me-1"></i>
								Prossimo punto firma
							</button>
						} @else {
							<div class="text-success small fw-bold">
								<i class="bi bi-check-circle me-1"></i>
								Documento firmato
							</div>
						}
					</div>

					<!-- Controlli di Zoom e Navigazione -->
					<div class="viewer-controls mb-4 d-flex align-items-center gap-3">
						<div class="nav-controls d-flex align-items-center gap-3 px-3 py-2 bg-light rounded-pill shadow-sm">
							<i class="bi bi-chevron-left cursor-pointer" (click)="prevPage()"></i>
							<span class="page-count text-muted">{{ currentPage() }} / {{ totalPages() }}</span>
							<i class="bi bi-chevron-right cursor-pointer" (click)="nextPage()"></i>
						</div>
						<div class="zoom-controls d-flex align-items-center gap-3 px-3 py-2 bg-light rounded-pill shadow-sm">
							<i class="bi bi-dash-lg cursor-pointer" (click)="zoomOut()"></i>
							<i class="bi bi-plus-lg cursor-pointer" (click)="zoomIn()"></i>
						</div>
					</div>
				}
			</div>
		</div>
	}
	@if (loadingAction()) {
		<div class="loading-overlay-fixed">
			<div class="spinner-border" role="status"></div>
			<span>Firma in corso...</span>
		</div>
	}
</div>
